// مثال: تعديل PrintableBookings.js لإصلاح مشكلة التداخل

import React, { forwardRef } from 'react';
import styles from './PrintableReport.module.css';
import { formatNumber } from '../../utils/formatters';

const PrintableBookings = forwardRef(({ bookings, settings, filters }, ref) => {
    if (!bookings || !settings) {
        return null;
    }

    // ... باقي الدوال المساعدة ...

    const totals = bookings.reduce((acc, booking) => {
        acc.total_price += parseFloat(booking.total_price || 0);
        acc.total_paid += parseFloat(booking.total_paid || 0);
        acc.remaining_amount += parseFloat(booking.remaining_amount || 0);
        return acc;
    }, { total_price: 0, total_paid: 0, remaining_amount: 0 });

    return (
        <div ref={ref} className={styles.printContainer}>
            
            {/* الهيدر */}
            <header className={styles.printHeader}>
                {settings.banner && (
                    <img src={settings.banner} alt="Company Banner" className={styles.bannerImage} />
                )}
            </header>

            {/* المحتوى الرئيسي - الآن مع padding-bottom */}
            <main className={styles.printContent}>
                <h1 className={styles.mainTitle}>تقرير الحجوزات</h1>
                
                {/* معلومات الفلاتر */}
                <div className={styles.filterInfo}>
                    {/* ... */}
                </div>

                {/* قسم الإحصائيات */}
                <section className={styles.section}>
                    <h2 className={styles.sectionTitle}>📊 الإحصائيات</h2>
                    <div className={styles.summaryGrid}>
                        {/* البطاقات */}
                    </div>
                </section>

                {/* 
                    ✅ الحل المطبق: قسم الجدول مع margin-bottom إضافي
                    إذا كان هذا القسم الأخير، سيحصل على margin-bottom: 100px تلقائياً
                */}
                <section className={styles.tableSection}>
                    <h2 className={styles.sectionTitle}>📅 قائمة الحجوزات ({bookings.length} حجز)</h2>
                    
                    {bookings.length > 0 ? (
                        <div className={styles.tableContainer}>
                            <table className={styles.reportTable}>
                                <thead>
                                    <tr>
                                        <th>#</th>
                                        <th style={{width: '25%'}}>العميل</th>
                                        <th>نوع الحجز</th>
                                        <th>تاريخ الحجز</th>
                                        <th>الحالة</th>
                                        <th>الإجمالي</th>
                                        <th>المدفوع</th>
                                        <th>المتبقي</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {bookings.map((booking, index) => (
                                        <tr key={booking.id}>
                                            <td style={{ textAlign: 'center' }}>{index + 1}</td>
                                            <td>{booking.client?.name || 'غير محدد'}</td>
                                            <td style={{ textAlign: 'center' }}>{booking.booking_type}</td>
                                            <td style={{ textAlign: 'center' }}>{booking.booking_date}</td>
                                            <td style={{ textAlign: 'center' }}>{booking.status}</td>
                                            <td className={styles.amountCell}>{formatNumber(booking.total_price, 0)}</td>
                                            <td className={styles.amountCell}>{formatNumber(booking.total_paid, 0)}</td>
                                            <td className={styles.amountCell}>{formatNumber(booking.remaining_amount, 0)}</td>
                                        </tr>
                                    ))}
                                </tbody>
                                <tfoot>
                                    {/* صف الإجماليات */}
                                    <tr>
                                        <td colSpan="5">الإجمالي الكلي:</td>
                                        <td className={styles.amountCell}>{formatNumber(totals.total_price, 0)}</td>
                                        <td className={styles.amountCell}>{formatNumber(totals.total_paid, 0)}</td>
                                        <td className={styles.amountCell}>{formatNumber(totals.remaining_amount, 0)}</td>
                                    </tr>
                                    
                                    {/* 
                                        ⬅️ اختياري: إضافة صف فارغ كـ spacer إضافي
                                        استخدم هذا فقط إذا استمرت المشكلة بعد تطبيق حلول CSS
                                    */}
                                    {/* 
                                    <tr style={{ 
                                        height: '80px', 
                                        border: 'none',
                                        visibility: 'hidden'
                                    }}>
                                        <td colSpan="8">&nbsp;</td>
                                    </tr>
                                    */}
                                </tfoot>
                            </table>
                        </div>
                    ) : (
                        <p style={{ textAlign: 'center', padding: '20px' }}>
                            لا توجد حجوزات تطابق الفلاتر المحددة.
                        </p>
                    )}
                </section>
                
                {/* 
                    ✅ في حال وجود أقسام إضافية بعد الجدول
                    تأكد من إضافة مساحة كافية للقسم الأخير
                */}
            </main>

            {/* 
                ✅ الفوتر المثبت - الآن مع ارتفاع محدد وz-index
                لن يتداخل مع المحتوى بسبب:
                1. @page margin-bottom: 2.8cm
                2. .printContent padding-bottom: 90px
                3. .tableSection:last-of-type margin-bottom: 100px
            */}
            <footer className={styles.printFooter}>
                <div className={styles.footerContent}>
                    {settings.company_name && <p>{settings.company_name}</p>}
                    {settings.phone_number && <p>{settings.phone_number}</p>}
                    {settings.address && <p>{settings.address}</p>}
                </div>
            </footer>
        </div>
    );
});

PrintableBookings.displayName = 'PrintableBookings';

export default PrintableBookings;